export const ADD_STUDENT = 'ADD_STUDENT';
export const ADD_LEAD = 'ADD_LEAD';
export const UPDATE_LEAD = 'UPDATE_LEAD';
